import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { Loader2 } from "lucide-react";
import MobilWashLogo from "@/components/MobilWashLogo";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Handles the #session_id=... redirect returned by Emergent Auth.
 * Exchanges the session_id with the backend (which sets the httpOnly cookie),
 * then redirects to /my-bookings.
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
 */
const AuthCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    // Clear the fragment so it isn't reused / logged
    window.history.replaceState({}, "", window.location.pathname + window.location.search);

    if (!sessionId) {
      navigate("/account", { replace: true });
      return;
    }

    (async () => {
      try {
        await axios.post(
          `${API}/customer/auth/session`,
          { session_id: sessionId },
          { withCredentials: true }
        );
        navigate("/my-bookings", { replace: true });
      } catch {
        navigate("/account?error=1", { replace: true });
      }
    })();
  }, [location.hash, navigate]);

  return (
    <div className="min-h-screen bg-[#0A192F] flex flex-col items-center justify-center gap-4" data-testid="auth-callback">
      <MobilWashLogo className="h-12" />
      <div className="flex items-center gap-3 text-gray-400 font-body">
        <Loader2 className="w-5 h-5 animate-spin text-teal-500" />
        Signing you in…
      </div>
    </div>
  );
};

export default AuthCallback;
